var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-authorized"},[_c('h1',[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"not-authorized-nav"},[_c('idf-button',{on:{"click":_vm.logout}},[_vm._v(" Retour à la page de connexion ")]),_c('idf-button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Retour ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }